import React from 'react';

import type { FormikErrors, FormikTouched } from 'formik';

import TextField from 'form-elements/text-field';

import type { UpdateFreelancerPersonalInformationType } from 'state/remote/remote-freelancer/use-update-freelancer-personal-information';

import Typography from 'components-new/typography/typography';

import { createLocale } from 'locales';

interface AddressFieldProps {
  errors: FormikErrors<UpdateFreelancerPersonalInformationType>;
  touched: FormikTouched<UpdateFreelancerPersonalInformationType>;
}

const AddressField: React.FC<AddressFieldProps> = ({ errors, touched }) => {
  const localize = createLocale('freelancerPersonalInformationPageLocales');
  const showError: boolean = !!(
    (errors?.postalCode && touched?.postalCode) ||
    (errors?.houseNumber && touched?.houseNumber) ||
    (errors?.houseNumberAddition && touched?.houseNumberAddition)
  );

  return (
    <div>
      <div className="flex items-end">
        <TextField
          name="postalCode"
          showError={false}
          type="text"
          className="mt-2"
          placeholder="1000AZ"
          title={localize('formPostalCode')}
        />
        <TextField
          name="houseNumber"
          showError={false}
          type="text"
          className="mt-2 mx-2"
          placeholder="1"
          title={localize('formHouseNumber')}
        />
        <TextField
          name="houseNumberAddition"
          showError={false}
          type="text"
          className="mt-2"
          placeholder="A"
          title={localize('formHouseNumberAddition')}
        />
      </div>
      {showError && (
        <Typography
          variant="body-medium"
          as="p"
          className="text-destructive mt-1"
        >
          {localize('formAddressError')}
        </Typography>
      )}
    </div>
  );
};

export default AddressField;
